import colors from "./colors";
import fonts, {
  AvenirNextLTComRegular,
  AvenirNextLTComDemi,
  AvenirNextLTComDemiIt,
  AvenirNextLTComBold,
} from "./fonts";

const styleOverrides = {
  html: [
    { "@font-face": AvenirNextLTComRegular },
    { "@font-face": AvenirNextLTComDemi },
    { "@font-face": AvenirNextLTComDemiIt },
    { "@font-face": AvenirNextLTComBold },
  ],

  body: {
    color: colors.black[100],
    fontFamily: fonts.regular,
    backgroundColor: colors.white,
  },
};

export default styleOverrides;
